import React, { useContext } from 'react';
import './Dashboard.scss';
import { VendersContext } from './../../context/Store';
function Dashboard() { 
    let { isLang } = useContext(VendersContext);
    return (
        <>

            <div className="welcome__page   bg-body  " style={{ display: 'flex ', justifyContent: 'center', alignItems: 'center' }}>
                <div className="title_Dynamic bg-blue-100 border-round shadow  rounded-3">
                    <h3> {isLang==="en"?'Dashboard  Al-watan Factory   ':'لوحة تحكم مصــنع الوطـــن'}   </h3>
                </div>
            </div>

        </>
    )
}

export default Dashboard